// classnames helper minimal — concatena clases tirando false/null/undefined.
export function cn(...args: Array<string | false | null | undefined>): string {
  return args.filter(Boolean).join(' ');
}
